/**
 * The MEMBER-facing live draft WATCH (Loop Studio).
 *
 * `loops.drafts.watch` follows one draft and delivers a whole
 * {@link LoopDraftView} per committed write — pushed from the write, never
 * polled. The first element is the draft as it stands when the watch opens; the
 * LAST element is the close, carrying `status: "published" | "discarded"`,
 * after which the stream ends.
 *
 * Contracts only — the handler lives in `loop-drafts-watch.router.ts`. The
 * error union deliberately carries no Redis error: the handler maps a stream
 * transport failure to `DatabaseError`.
 *
 * @since 1.0.0
 */
import { Rpc, RpcGroup } from "@effect/rpc";
import { Schema } from "effect";

import { DatabaseError, Forbidden, RecordNotFoundError, Unauthorized, ValidationError } from "../errors.ts";
import { LoopActorMiddleware } from "../loop-actor.tags.ts";
import { LoopDraftRefInput, LoopDraftView } from "./loop-drafts.rpc.ts";

/**
 * The member-facing draft watch group — one streaming rpc behind
 * {@link LoopActorMiddleware}.
 *
 * @since 1.0.0
 */
export class LoopDraftWatchRpcs extends RpcGroup.make(
  Rpc.make("loops.drafts.watch", {
    payload: LoopDraftRefInput,
    success: LoopDraftView,
    error: Schema.Union(Unauthorized, Forbidden, RecordNotFoundError, ValidationError, DatabaseError),
    stream: true,
  }).middleware(LoopActorMiddleware),
) {}
